module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (31).72aaa8b4.jpg";